import React from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../EditorContext";
import { Close, Info } from "../../Misc/Icons";

var HelpPopup = function HelpPopup(_ref) {
  var EditorContext = _ref.EditorContext;
  var _EditorContext$state = EditorContext.state,
      displayHelp = _EditorContext$state.displayHelp,
      tutorialLink = _EditorContext$state.tutorialLink;

  var closePopup = function closePopup() {
    return EditorContext.setHelpModalVisibility(false);
  };

  return displayHelp && React.createElement("div", {
    className: "recorder__tooltip"
  }, React.createElement("div", {
    className: "tooltip"
  }, React.createElement("div", {
    className: "tooltip__icon"
  }, React.createElement(Info, null)), React.createElement("div", {
    className: "tooltip__title"
  }, "Learn how video editing works"), React.createElement("div", {
    className: "tooltip__text"
  }, "Watch our short tutorial on how to add overlay graphics to your video."), React.createElement("div", {
    className: "tooltip__buttons"
  }, React.createElement("a", {
    className: "button button--size-s button--color-gigas button--style-default",
    href: tutorialLink,
    target: "_blank"
  }, "watch tutorial"), React.createElement("button", {
    className: "button button--size-s button--style-default tooltip__buttons-dismiss",
    onClick: closePopup
  }, "maybe later")), React.createElement("button", {
    className: "tooltip__close button button--link",
    onClick: closePopup
  }, React.createElement(Close, null))));
};

HelpPopup.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired
} : {};
export default consumeContext(HelpPopup);